var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('router-view'),(_vm.showThemeSelector)?_c('theme-selector',{attrs:{"current-theme":_vm.currentTheme},on:{"change-theme":_vm.selectTheme}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }